var map = {
	"./action.svg": 13,
	"./contact.svg": 14,
	"./logo.svg": 15,
	"./mag.svg": 16,
	"./recruit.svg": 17,
	"./scroll.svg": 18,
	"./search.svg": 19
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;


//////////////////
// WEBPACK FOOTER
// ./img/common ../node_modules/svg-inline-loader?classPrefix ^\.\/.*\.svg$
// module id = 12
// module chunks = 0